"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortingContext = exports.SortingContext = void 0;
var react_1 = __importStar(require("react"));
var useHasSortingColumns_1 = __importDefault(require("./useHasSortingColumns"));
var constants_1 = require("../../constants");
exports.SortingContext = (0, react_1.createContext)({});
var useSortingContext = function () { return (0, react_1.useContext)(exports.SortingContext); };
exports.useSortingContext = useSortingContext;
var SortingProvider = function (_a) {
    var columns = _a.columns, children = _a.children, sortField = _a.sortField, sortOrder = _a.sortOrder, handlerSorting = _a.onSorting, sortingType = _a.sortingType;
    var _b = (0, react_1.useState)(function () { return ({
        sortField: sortField,
        sortOrder: sortOrder,
    }); }), sortingSettings = _b[0], setSortingSettings = _b[1];
    var _c = (0, react_1.useState)({ selectedField: '', selectedCount: 0 }), selectedSortingSettings = _c[0], setSelectedSortingSettings = _c[1];
    var hasSortingColumns = (0, useHasSortingColumns_1.default)(columns);
    var firstSortingColumn = (0, react_1.useMemo)(function () { return columns.find(function (_a) {
        var isSorting = _a.isSorting;
        return isSorting;
    }); }, [columns]);
    var onSorting = (0, react_1.useCallback)(function (field, order) {
        var newSortField = field;
        var newSortOrder = order;
        if (sortingType === constants_1.SORTING_TYPES.threeStateSort) {
            if (selectedSortingSettings.selectedCount === 2 && selectedSortingSettings.selectedField === field) {
                newSortField = firstSortingColumn === null || firstSortingColumn === void 0 ? void 0 : firstSortingColumn.id;
                newSortOrder = 0;
                setSelectedSortingSettings({
                    selectedField: newSortField,
                    selectedCount: 1
                });
            }
            else if (selectedSortingSettings.selectedField !== field) {
                setSelectedSortingSettings({
                    selectedField: field,
                    selectedCount: 1
                });
            }
            else {
                setSelectedSortingSettings({
                    selectedField: field,
                    selectedCount: selectedSortingSettings.selectedCount + 1
                });
            }
        }
        setSortingSettings(function () { return ({ sortField: newSortField, sortOrder: newSortOrder }); });
        handlerSorting(newSortField, newSortOrder);
    }, [
        setSortingSettings,
        selectedSortingSettings,
        setSelectedSortingSettings,
        sortingType,
        firstSortingColumn,
        handlerSorting
    ]);
    (0, react_1.useEffect)(function () {
        if (sortingSettings.sortField !== sortField && sortingSettings.sortOrder !== sortOrder) {
            setSortingSettings({ sortField: sortField, sortOrder: sortOrder });
        }
        // eslint-disable-next-line
    }, [sortField, sortOrder, setSortingSettings]);
    var value = (0, react_1.useMemo)(function () { return ({
        sortingSettings: sortingSettings,
        setSortingSettings: setSortingSettings,
        onSorting: onSorting,
        hasSortingColumns: hasSortingColumns,
        handlerSorting: handlerSorting
    }); }, [sortingSettings, setSortingSettings, onSorting, hasSortingColumns, handlerSorting]);
    return (react_1.default.createElement(exports.SortingContext.Provider, { value: value }, children));
};
exports.default = SortingProvider;
